import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import StudentSwitcher from '../../../core/identity-access/components/StudentSwitcher';
import './Sidebar.css';

export interface MenuItem {
  path: string;
  label: string;
  icon: React.ReactNode;
  badge?: string | number;
}

export interface SidebarProps {
  isOpen: boolean;
  menuItems: MenuItem[];
  onClose?: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ isOpen, menuItems, onClose }) => {
  const location = useLocation();
  // On desktop: isOpen=false means collapsed (icon-only). On mobile it means hidden.
  const isCollapsed = !isOpen;

  const isActivePath = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <>
      {/* Mobile overlay */}
      {/* Mouse affordance only: the drawer is dismissed from the keyboard with
          the menu toggle that opened it, so a tab stop here would announce
          nothing (S11.2). */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose} aria-hidden />}

      <aside className={`app-sidebar ${isOpen ? 'open' : 'collapsed'}`}>
        <nav className="sidebar-nav">
          <ul className="sidebar-menu">
            {menuItems.map((item) => (
              <li key={item.path} className="sidebar-menu-item">
                <Link
                  to={item.path}
                  className={`sidebar-link ${isActivePath(item.path) ? 'active' : ''}`}
                  onClick={onClose}
                  title={isCollapsed ? item.label : undefined}
                >
                  <span className="sidebar-icon">{item.icon}</span>
                  <span className="sidebar-label">{item.label}</span>
                  {item.badge && <span className="sidebar-badge">{item.badge}</span>}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* Student switcher — shown only for PARENT users (self-manages visibility) */}
        <div className="sidebar-footer">
          <StudentSwitcher isCollapsed={isCollapsed} />
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
